import { ChangeDetectionStrategy, Component, Input, ChangeDetectorRef, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { Subject } from 'rxjs';
import { MediaObserver } from '@angular/flex-layout';
import { LinkCard } from '~app/modules/storyblok/models';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';
import { GaTrackingEventAction, GaTrackingEventName, GATrackingEventType } from '~shared/modules/ga-tracking/constants';

@Component({
  selector: 'app-popular-links',
  templateUrl: './popular-links.component.html',
  styleUrls: ['./popular-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopularLinksComponent implements OnInit {
  @Input() title: string;
  @Input() linkList: Array<LinkCard>;

  private unsubscribe$ = new Subject<void>();

  isMobile = true;

  constructor(
    private mediaObserver: MediaObserver,
    private cd: ChangeDetectorRef,
    private gtmDatalayerService: GtmDatalayerService
  ) {}

  ngOnInit(): void {
    this.initMediaObserver();
  }

  initializePopularLinksView(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_POPULAR_LINKS_VIEWED,
      GA_eventname: GaTrackingEventName.Interaction,
      action: GaTrackingEventAction.POPULAR_LINKS_VIEWED,
    });
  }

  private initMediaObserver(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
        this.cd.markForCheck();
      });
  }
}
